import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';
export const DownloadIcon = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M22 31.5858V1C22 0.447716 21.5523 0 21 0C20.4477 0 20 0.447716 20 1V31.6988L6.68232 19.2689C6.27857 18.8921 5.64578 18.9139 5.26894 19.3177C4.89211 19.7214 4.91393 20.3542 5.31768 20.7311L19.6114 34.0719C20.3993 34.8072 21.6282 34.786 22.3902 34.024L35.7071 20.7071C36.0976 20.3166 36.0976 19.6834 35.7071 19.2929C35.3166 18.9024 34.6834 18.9024 34.2929 19.2929L22 31.5858Z'
				fill={color ? handleColorType(color, theme) : '#616161'}
			/>
			<path
				d='M0 41C0 40.4477 0.447715 40 1 40H41C41.5523 40 42 40.4477 42 41C42 41.5523 41.5523 42 41 42H1C0.447715 42 0 41.5523 0 41Z'
				fill={color ? handleColorType(color, theme) : '#616161'}
			/>
		</svg>
	);
};
